import $ from 'jquery';
import mapStyles from './mapstyle';

$(function () {
    // initialize map if found
    if ($('[data-map]').length > 0) {
        var map,
            $map = $('[data-map]'),
            lat = $map.data('lat'),
            lon = $map.data('lon'),
            zoom = $map.data('zoom'),
            title = $map.data('title');

        function initialize() {
            var mapOptions = {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                    position: google.maps.ControlPosition.DEFAULT
                },
                zoom: zoom,
                zoomControl: true,
                minZoom: 2,
                maxZoom: 15,
                panControl: false,
                streetViewControl: false,
                scaleControl: false,
                scrollwheel: false,
                overviewMapControl: false,
                center: new google.maps.LatLng(lat, lon)
            };

            map = new google.maps.Map(document.querySelector('[data-map]'), mapOptions);
            map.setOptions({styles: mapStyles});

            var mapIcon = {
                path: 'M16.5,51s-16.5-25.119-16.5-34.327c0-9.2082,7.3873-16.673,16.5-16.673,9.113,0,16.5,7.4648,16.5,16.673,0,9.208-16.5,34.327-16.5,34.327zm0-27.462c3.7523,0,6.7941-3.0737,6.7941-6.8654,0-3.7916-3.0418-6.8654-6.7941-6.8654s-6.7941,3.0737-6.7941,6.8654c0,3.7916,3.0418,6.8654,6.7941,6.8654z',
                anchor: new google.maps.Point(16.5, 51),
                fillColor: '#FFF100',
                fillOpacity: 0.7,
                strokeWeight: 0,
                scale: 1
            };

            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lon),
                map: map,
                icon: mapIcon,
                title: title
            });
        }

        google.maps.event.addDomListener(window, 'load', initialize);

        function checkResize(){
            if (map && map.getCenter) {
                var center = map.getCenter();
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
            }
        }

        window.onresize = checkResize;
    }
});